import { render, staticRenderFns } from "./RStepNav.vue?vue&type=template&id=631b6994&scoped=true"
import script from "./RStepNav.vue?vue&type=script&lang=js"
export * from "./RStepNav.vue?vue&type=script&lang=js"
import style0 from "./RStepNav.vue?vue&type=style&index=0&id=631b6994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "631b6994",
  null
  
)

export default component.exports